import EmailOutlined from '@material-ui/icons/EmailOutlined';
import React from 'react';
import { useHistory } from '~frontend-common/hooks/use-history';
import { useTranslator } from '~frontend-common/i18n/translator';
import { Box } from '~ui-kit/components/box/box';
import { Card } from '~ui-kit/components/card/card';
import { TextInput } from '~ui-kit/components/text-input';
import { useDialogState } from '~ui-kit/hooks/use-dialog-state';
import { PageContentContainer } from '~web-portal/components/page-content-container';
import { PageHeader } from '~web-portal/components/page-header';
import { useUserStore } from '~web-portal/stores';
import { Paths } from '~web-portal/variables/paths';
import { DetailRow } from './components/detail-row';
import { EditActions } from './components/edit-actions';
import { EditEmailDialog } from './components/edit-email-dialog';
import { PhoneNumberForm } from './components/phone-number-form';

export function ProfilePage() {
  const history = useHistory();
  const { tl } = useTranslator();
  const editEmailDialog = useDialogState();
  const user = useUserStore.use.user();
  const getFullName = useUserStore.use.getFullName();

  const handleBack = () => {
    history.push(Paths.policies);
  };

  return (
    <Box data-id="profile-page" flexDirection="column" flex="1 1 auto">
      <PageContentContainer>
        <PageHeader
          title={tl('profile.title')}
          subtitle={tl('profile.subtitle')}
          mb={5}
          backButtonOnClick={handleBack}
        />

        <Card minHeight="35vh" flexDirection="column" justifyContent="center">
          {user && (
            <Box flexDirection="column" gridGap={3}>
              <DetailRow>
                <TextInput variant="outlined" label={tl('profile.fields.name')} value={getFullName()} disabled={true} />
              </DetailRow>

              <DetailRow>
                <TextInput
                  label={tl('profile.fields.email')}
                  type="email"
                  autoComplete="email"
                  variant="outlined"
                  value={user.email}
                  disabled={true}
                  startIcon={<EmailOutlined />}
                  endIcon={<EditActions name="email" inplaceEdit={false} onEdit={editEmailDialog.open} />}
                />
              </DetailRow>

              <PhoneNumberForm value={user.phoneNumber} />
            </Box>
          )}
        </Card>

        <EditEmailDialog isOpen={editEmailDialog.isOpen} onClose={editEmailDialog.close} />
      </PageContentContainer>
    </Box>
  );
}
